import { VStack } from '@chakra-ui/react';
import { useDonationSubmit } from '../../hooks';
import {
  DonationHeader,
  ErrorNotification,
  ScrollToTop,
} from '../../components';
import { DonationForm } from './DonationForm';

export const Donation = () => {
  const { errorMessage, handleFormSubmit, isLoading } = useDonationSubmit();

  return (
    <VStack spacing={10} mb={12} align="left">
      {!!errorMessage?.message && (
        <>
          <ScrollToTop />
          <ErrorNotification
            title={errorMessage.title}
            description={errorMessage?.message}
          />
        </>
      )}
      <DonationHeader />
      <DonationForm handleFormSubmit={handleFormSubmit} isLoading={isLoading} />
    </VStack>
  );
};
